/**
 * Created by Administrador on 10/24/2016.
 */
(function(){
    'use strict';

    var controlWizard = {
        templateUrl: 'app/components/wizard/controlWizard.html',
        controller: controlWizardController,
        controllerAs: 'vm',
        bindings:{
            formWizard: '=',
            formPrevious: '@',
            formNext: '='
        }
    };

    angular
        .module('completeAir')
        .component('controlWizard', controlWizard);

    function controlWizardController(){
        var vm = this;
    }

})();
